var __default__ = {day:'m_396ce5cb'};
export default __default__;